/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import dayjs from "dayjs";

const getRows = (data, handleSelect, handleOpenRemitosOP) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleSelect(item)}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title={item.tipo} placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  color="primary"
                  fontSize="lg"
                >
                  request_page
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        // ordenPago: (
        //   <SoftBox
        //     sx={{
        //       cursor: "pointer",
        //     }}
        //     onClick={() => handleSelect(item)}
        //   >
        //     <SoftTypography
        //       verticalAlign="text-top"
        //       variant="caption"
        //       color="dark"
        //       fontWeight="bold"
        //     >
        //       {item?.ordenPago}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        proveedor: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleSelect(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.proveedor?.razonSocial ||
                `${item?.proveedor?.nombre} - ${item?.proveedor?.nombre}`}
            </SoftTypography>
          </SoftBox>
        ),
        fechaEntrega: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleSelect(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.fechaEntrega).format("DD/MM/YYYY")}
            </SoftTypography>
          </SoftBox>
        ),
        // fechaOrdenPago: (
        //   <SoftBox
        //     sx={{
        //       cursor: "pointer",
        //     }}
        //     onClick={() => handleSelect(item)}
        //   >
        //     <SoftTypography
        //       verticalAlign="text-top"
        //       variant="caption"
        //       color="secondary"
        //       fontWeight="medium"
        //     >
        //       {dayjs(item?.fechaOrdenPago).format("DD/MM/YYYY")}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        user: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleSelect(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.user?.username}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              cursor: "default",
              whiteSpace: "nowrap",
              minWidth: "72px",
            }}
          >
            {handleOpenRemitosOP &&
              (() => {
                const hasOP = !!item?.provision?.id;
                return (
                  <Tooltip
                    title={hasOP ? "Ver remitos de la OP" : "Sin orden de provisión"}
                    placement="top"
                  >
                    <Icon
                      sx={{
                        cursor: hasOP ? "pointer" : "not-allowed",
                        mx: 0.5,
                        color: hasOP ? getUproColor("uproBlue") : "#cbd5e1",
                      }}
                      fontSize="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (hasOP) handleOpenRemitosOP(item);
                      }}
                    >
                      inventory
                    </Icon>
                  </Tooltip>
                );
              })()}
            <Tooltip title="Ver detalles" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={() => handleSelect(item)}
              >
                arrow_forward
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  // { name: "ordenPago", desc: "Orden Pago", align: "left" },
  { name: "proveedor", desc: "Proveedor", align: "left", orderField: "idProveedor" },
  { name: "fechaEntrega", desc: "Fecha de Entrega", align: "left" },
  // { name: "fechaOrdenPago", desc: "Fecha Orden Pago", align: "left" },
  { name: "user", desc: "Creado por", align: "left", orderField: "idUser" },
  { name: "accion", desc: " ", align: "center", width: "1%" },
];

export default { columns, getRows };
